export const routes = {
  // Restricted
  dashboard: '/dashboard',
  myAccount: '/my-account',
  settings: '/settings',
  products: '/products',
  loans: '/loans',
  // Restricted
  home: '/',
  login: '/login',
  termsOfService: '/terms-of-service',
  privacyPolicy: '/privacy',
  help: '/help'
};